import { render, staticRenderFns } from "./GazDeBordeaux.vue?vue&type=template&id=d88e147c"
import script from "./GazDeBordeaux.vue?vue&type=script&lang=js"
export * from "./GazDeBordeaux.vue?vue&type=script&lang=js"
import style0 from "./GazDeBordeaux.vue?vue&type=style&index=0&id=d88e147c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports